export const environment = {
  production: false,
  appId: "hotelmate",
  homeAddress: "https://bookonelocal.in",
  masterProductUrl:"",
  // masterProductUrl:"https://masterdata.bookonepms.com",
  apiUrl: "https://api.uat.thehotelmate.co",
  apiUrlInventory: "https://api.thehotelmate.co/api-ims",
  apiUrlEms: "https://api.thehotelmate.co/api-ems",
  apiUrllms: "https://api.thehotelmate.co/api-lms",
  cmApiUrl: "https://api.bookonelocal.in/channel-integration",
  addressUrl: "https://api.thehotelmate.co/api-address",
  apiUrlPromotion: "https://api.uat.bookone.io/promotion",
  scheduleApiUrl: "https://scheduler.api.bookone.io",
  apiEglobe: "https://api.thehotelmate.co/api-eglobe",
  apiGoogle: "https://testapi.bookonelocal.co.nz/api-google-hotels",
  // apiUrlPromotion: "https://api.uat.bookone.io/promotion",

  googleHotelUrl: "https://n-a.com",
  country: "in",
  showLog: true,
  parentOrganisationId: 1,
};
